import { IPatient } from '@medlogic/shared/shared-interfaces';
import { EntityState } from '@ngrx/entity';

export interface IPatientState extends EntityState<IPatient> {
    // additional entities state properties
    error: any;
    selectedId: number | null;
}
